import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SapiPrice } from 'src/app/models/amazon';
import { EbayBrowseItemSummery } from 'src/app/models/ebay';
import { AmazonService } from 'src/app/services/amazon.service';
import { EbayService } from 'src/app/services/ebay.service';
import { PriceMatcherService, Pricing, PricingSearchParams } from 'src/app/services/pricematcher.service';

@Component({
    selector: 'app-pricing-screen',
    templateUrl: './pricing-screen.component.html',
    styleUrls: ['./pricing-screen.component.css'],
    standalone: false
})
export class PricingScreenComponent implements OnInit{

  sapiPrice: SapiPrice;
  ebayPrices: SapiPrice;

  //selectedPrices: SapiPrice;
  price: Pricing;

  itemSold = 0;
  itemCost = 0;
  platformFee = 0;
  shippingCost = 0;
  shippingCharge = 0;
  transactionFeePercent = 0;
  transactionFeeCents = 0;
  lowestPrice = 0;
  highestPrice = 0;
  averageShipping = 0;

  // Output values
  platformFeeAmount = 0;
  transactionFeeAmount = 0;
  itemProfit = 0;
  totalCost = 0;
  totalProfit = 0;

  // Market display
  suggestedLowestPrice = 0;
  competitiveThreshold = 0;

  // Profit analysis
  lowestPriceProfit = 0;
  highestPriceProfit = 0;
  suggestedPriceProfit = 0;
  competitivePriceProfit = 0;
  shippingDiff = 0;

 
  constructor(private route: ActivatedRoute,
     private amazonService: AmazonService,
     private ebayService: EbayService,
     private router: Router,
    private service: PriceMatcherService) { }


  backBtn(){
    this.router.navigate(['/']);
    this.ebayService.clearEbayData();
  }


   // Helper functions
   calculateProfitForPrice(sellingPrice: number): number {
    sellingPrice = sellingPrice + this.shippingCharge;
    const platformFeeAmount = sellingPrice * (this.platformFee / 100);
    const transactionFeeAmount = (sellingPrice * this.transactionFeePercent / 100) + this.transactionFeeCents;
    const totalCost = this.itemCost + platformFeeAmount + transactionFeeAmount + this.shippingCost;
    return sellingPrice - totalCost;
  }

  formatProfitDisplay(profit: number): string {
    const formatted = profit.toFixed(2);
    if (profit > 0) return `Profit: $${formatted}`;
    if (profit < 0) return `Loss: $${Math.abs(profit).toFixed(2)}`;
    return 'Break-even: $0.00';
  }

  calculateProfit(): void {
    this.platformFeeAmount = this.itemSold * this.platformFee / 100;
    this.transactionFeeAmount = (this.itemSold * this.transactionFeePercent / 100) + this.transactionFeeCents;
    this.itemProfit = this.itemSold - this.itemCost;
    this.totalCost = this.itemCost + this.platformFeeAmount + this.transactionFeeAmount + this.shippingCost;
    this.totalProfit = this.itemSold - this.totalCost + this.shippingCharge;

    this.suggestedLowestPrice = this.lowestPrice * 1.05;
    this.competitiveThreshold = (this.lowestPrice + this.highestPrice) / 2;

    this.lowestPriceProfit = this.calculateProfitForPrice(this.lowestPrice);
    this.highestPriceProfit = this.calculateProfitForPrice(this.highestPrice);
    this.suggestedPriceProfit = this.calculateProfitForPrice(this.suggestedLowestPrice);
    this.competitivePriceProfit = this.calculateProfitForPrice(this.competitiveThreshold);

    this.shippingDiff = this.averageShipping - this.shippingCost;
  }

  
  private mapEbayPrices(response: EbayBrowseItemSummery){
    this.ebayPrices = null;
    if(response){
      this.ebayPrices = {
        source: 'eBay',
        asin: this.sapiPrice.asin,
        condition: response[0]? response[0].condition : 'New',
        offers: Number(response.total),
        lowest: Math.min.apply(Math, response.itemSummaries.map( (item) => { return item.price.value; })),
        highest: Math.max.apply(Math, response.itemSummaries.map( (item) => { return item.price.value; })),
        box: 0,
        suggested_lower_price: 0,
        competitive_price_threshold: 0
      };
    }
    
  }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe( async (params) => {
      let queryParams = {};
      for (let key in params) {
        queryParams[key] = params[key];
      };
      let asin: string = queryParams['asin'];
      let upc: string = params['upc'];
      const priceSearchParams: PricingSearchParams = new PricingSearchParams();
      priceSearchParams.upc = upc;
      const priceResponse = await this.service.getPrices(priceSearchParams);
      this.price = priceResponse.data[0];
      /*
      
      if(asin === undefined || asin === ''){
        this.mapEbayPrices(await this.ebayService.getStoredEbayData());
      
      }else{
        this.amazonService.getSapiPrices(asin)
      .then((response) => {
        this.sapiPrice = response;
        return this.ebayService.getStoredEbayData();
      })
      .then(response =>{
        this.mapEbayPrices(response);
      });
      }
      */
      
      
    });
  }
}
